<template>
  <div>
    <div>
      <v-btn
        @click="clipUrl = true"
        v-clipboard:copy="inviteUrl"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        color="#222288"
        tile
        style="font-size:16px"
        class="white--text my-3"
      >
        <b>このルームへの招待URLを発行</b>
      </v-btn>
    </div>
    <v-snackbar
      v-model="clipUrl"
      :timeout="timeout"
      top
    >
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="clipUrl = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  props: [],
  data: function() {
    return {
      clipUrl: false,
      timeout: 2000,
      snackText: "",
    }
  },
  computed: {
    getRoomId() {
      return this.$store.getters.roomId
    },
    inviteUrl() {
      var url = location.href;
      const urlElements = url.split('/');
      var inviteUrl = ""
      for (var i=0; i<3; i++){
        inviteUrl += urlElements[i]
        inviteUrl += '/'
      }
      inviteUrl += 'room'
      inviteUrl += this.getRoomId
      return inviteUrl
    }
  },
  methods: {
    onCopy: function () {
      this.snackText = "クリップボードにURLをコピーしました．"
    },
    onError: function () {
      this.snackText = "コピーに失敗しました．"
    }
  },
  created() {

  }
}
</script>
